import {
  DGTAS_USER_ID_LIST,
  SEEDN_USER_ID_LIST,
  SK_USER_ID_LIST,
} from 'constants';
import { changeField } from 'modules/authSlice';
import { useDispatch } from 'react-redux';
import {
  useLocation,
  useNavigate,
} from '../../../node_modules/react-router-dom/index';
import { useEffect } from 'react';

export const useCheckPartner = () => {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const location = useLocation();

  const userId = localStorage.getItem('userId');

  const isSeedn = SEEDN_USER_ID_LIST.some(id => id === Number(userId));

  const isSk = SK_USER_ID_LIST.some(id => id === Number(userId));

  const isDgtas = DGTAS_USER_ID_LIST.some(id => id === Number(userId));

  useEffect(() => {
    if (!isSeedn && location.pathname === '/admin/dashboard/place') {
      navigate('/admin/places');
    }

    if (isSeedn) {
      dispatch(changeField({ key: 'partner', value: 'seedn' }));
      return;
    }

    if (isSk) {
      dispatch(changeField({ key: 'partner', value: 'sk' }));
      return;
    }

    if (isDgtas) {
      dispatch(changeField({ key: 'partner', value: 'dgtas' }));
      return;
    }
  }, [isSeedn, isSk, isDgtas, navigate, location, dispatch]);
};
